import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class AppMessageService {

  private messageService = inject(MessageService);

  // constructor(private messageService: MessageService) { }

  success(message: string, header = 'Success!'): void {
    //this.messageService.add({ severity: 'error', summary: 'Failed!', detail: err.message, life: 3000 });
    this.messageService.add({
      severity: 'success',
      summary: header,
      detail: message,
    });
  }

  info(message: string, header = 'Info'): void {
    this.messageService.add({
      severity: 'info',
      summary: header,
      detail: message,
    });
  }

  warn(message: string, header = 'Warning'): void {
    this.messageService.add({
      severity: 'warn',
      summary: header,
      detail: message,
    });
  }

  error(message: string, header = 'Error'): void {
    this.messageService.add({
      severity: 'error',
      summary: header,
      detail: message,
    });
  }
}
